module.exports = __webpack_public_path__ + "img/Augenknoten.e80df10c.svg";